import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import SportCouponPageViewImpl from './sport-coupon-page-view.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * View that layouts a coupon as a sports sub-page.
 *
 * @class SportCouponPageView
 * @memberof Mojito.Applications.Sports.Pages.SportCouponPage
 */

/**
 * SportCouponPageView prop types.
 *
 * @property {string} sportId - The id of the currently selected sport.
 * @property {string} couponId - The id of the coupon to render.
 * @property {string} couponName - The name of the coupon to render.
 * @property {boolean} showEmptyContent - Set to true if the coupon doesn't exist.
 *
 * @memberof Mojito.Applications.Sports.Pages.SportCouponPage.SportCouponPageView
 */
const propTypes = {
    sportId: PropTypes.string.isRequired,
    couponId: PropTypes.string.isRequired,
    couponName: PropTypes.string,
    showEmptyContent: PropTypes.bool,
};

const defaultProps = {
    couponName: '',
};

export default UIView('SportCouponPageView', SportCouponPageViewImpl, propTypes, defaultProps);
